import { useFieldArray, useFormContext, FieldErrors, FieldValues, ArrayPath, FieldArray } from "react-hook-form";
import { YStack, XStack, Button, View, Text } from "tamagui";
import { colors } from "@styles/colors";
import FormItem from "@components/form/FormItem";
import { RiDeleteBinLine, RiAddLine } from "react-icons/ri";
import { combinedErrorMessage } from "@utils/func/textTool";

interface DynamicInputSectionProps<T extends FieldValues> {
  id: ArrayPath<T>;
  placeholder?: string;
  addButtonText?: string;
  maxItems?: number;
  parentError?: FieldErrors<T>[keyof T];
  defaultValue: FieldArray<T, ArrayPath<T>>;
}

const DynamicInputSection = <T extends FieldValues>({
  id,
  placeholder,
  addButtonText = "新增項目",
  maxItems = 5,
  parentError,
  defaultValue,
}: DynamicInputSectionProps<T>) => {
  const { control } = useFormContext<T>();

  const { fields, append, remove } = useFieldArray({
    control,
    name: id,
  });

  return (
    <YStack gap="$2" mb="$3">
      {fields.map((field, index) => (
        <YStack key={field.id}>
          <XStack gap="$2" ai="flex-end">
            <View f={1}>
              <FormItem
                itemType="input"
                required={false}
                data={{
                  id: `${id}.${index}.contactPhone`,
                  label: "",
                  placeholder: placeholder || "",
                }}
              />
            </View>
            <Button
              px="$2"
              py="$1"
              chromeless
              onPress={() => remove(index)}
              backgroundColor={colors.bgRed}
              pressStyle={{ backgroundColor: colors.bgRed, borderColor: colors.bgRed, borderWidth: 1 }}
              hoverStyle={{ backgroundColor: colors.bgRed, borderColor: colors.bgRed, borderWidth: 1 }}
              icon={<RiDeleteBinLine size={16} color={colors.darkRed} />}
            />
          </XStack>

          {Array.isArray(parentError) && parentError[index] && (
            <Text color="$red10" fontSize={12}>
              {combinedErrorMessage(parentError[index] as any)}
            </Text>
          )}
        </YStack>
      ))}

      {fields.length < maxItems && (
        <Button
          chromeless
          color={colors.primary}
          width="100%"
          size="$3"
          mt="$2"
          borderRadius="$4"
          borderWidth={1.5}
          borderStyle="dashed"
          borderColor={colors.primary}
          backgroundColor={colors.primaryActive}
          pressStyle={{ backgroundColor: colors.primaryActive, borderStyle: "dashed", borderColor: colors.primary, borderWidth: 1.5 }}
          hoverStyle={{ backgroundColor: colors.primaryActive, borderStyle: "dashed", borderColor: colors.primary, borderWidth: 1.5 }}
          onPress={() => append(defaultValue)}
          icon={<RiAddLine size={16} />}>
          <Text fontSize={14} color={colors.primary}>
            {addButtonText}
          </Text>
        </Button>
      )}
    </YStack>
  );
};

export default DynamicInputSection;
